import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=7a33fffa&scoped=true"
import script from "./academy.vue?vue&type=script&lang=js"
export * from "./academy.vue?vue&type=script&lang=js"
import style0 from "./academy.vue?vue&type=style&index=0&id=7a33fffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33fffa",
  null
  
)

export default component.exports